import React from 'react';
import Link from 'components/Link';
import { convertHtmlToStringText } from 'utils/common';
import Card from '../Card';
import MediaIcon from './MediaIcon';

function renderTimeStamp(item, timeStampFun, timeStampFormat) {
  let timestampHtml = null;
  const timestamp = item.upd || item.lpt || item.dl || null;
  if (timestamp && timeStampFun && timeStampFormat) {
    timestampHtml = timeStampFun(timestamp, timeStampFormat);
  }
  return timestampHtml;
}

function renderList(
  data,
  nonFeaturedItemWrapperClass,
  itemClass,
  nonFeaturedListTileType = 'isVerticalTile',
  newga,
  htmlKeys,
  imgFit,
  imgWidth,
  isInlineSmallIconCard,
  timeStampFun,
  timeStampFormat,
) {
  return (
    data instanceof Array &&
    data.map((item, index) => {
      const spotlightGA =
        item.ag && item.ag === 'spotlight'
          ? `sl_${index + 1}_${item.id}`
          : null;
      if (item.tn !== 'featured') {
        return (
          <div
            className={nonFeaturedItemWrapperClass}
            key={`non_featured_${index}`}
          >
            {!(typeof item.image === 'object') ? (
              <>
                <MediaIcon type={item.type} />
                <Link
                  to={item.wu}
                  className={itemClass}
                  data-newga={`${newga}${index}/${item.wu}`}
                >
                  {htmlKeys &&
                  htmlKeys instanceof Array &&
                  htmlKeys.indexOf('hl') > -1
                    ? convertHtmlToStringText(item.hl)
                    : item.hl}
                </Link>
              </>
            ) : (
              [
                nonFeaturedListTileType !== 'isVerticalTile' ? (
                  <Card
                    data={item}
                    itemClass={itemClass}
                    tileType="nonFeaturedListTileType"
                    newga={`${newga}${item.wu || index}`}
                    htmlKeys={htmlKeys}
                    imgFit={imgFit}
                    imgWidth={imgWidth}
                    key={item.id || `${item.tn}_${index}`}
                    isInlineSmallIconCard={isInlineSmallIconCard}
                    timeStampHtml={renderTimeStamp(
                      item,
                      timeStampFun,
                      timeStampFormat,
                    )}
                    viewga={spotlightGA}
                  />
                ) : (
                  <Card
                    data={item}
                    itemClass={itemClass}
                    isVerticalTile
                    newga={`${newga}${item.wu || index}`}
                    htmlKeys={htmlKeys}
                    imgFit={imgFit}
                    imgWidth={imgWidth}
                    key={item.id || `${item.tn}_${index}`}
                    isInlineSmallIconCard={isInlineSmallIconCard}
                    timeStampHtml={renderTimeStamp(
                      item,
                      timeStampFun,
                      timeStampFormat,
                    )}
                    viewga={spotlightGA}
                  />
                ),
              ]
            )}
          </div>
        );
      }
      return null;
    })
  );
}

function CardList(props) {
  const {
    data = [],
    showDescription,
    nonFeaturedListWrapperClass,
    nonFeaturedItemWrapperClass,
    itemClass,
    featuredCardType,
    nonFeaturedListTileType,
    htmlKeys,
    imgFit,
    imgWidth,
    isInlineSmallIconCard = false,
    timeStampFun,
    timeStampFormat,
    isPrimeStory,
  } = props;
  const featured =
    data instanceof Array &&
    data.filter(item => (item.tn === 'featured' ? item : null));

  return (
    <>
      {data instanceof Array &&
        featured.map((item, index) => {
          const spotlightGA =
            item.ag && item.ag === 'spotlight'
              ? `sl_${index + 1}_${item.id}`
              : null;
          return (
            <Card
              data={item}
              showDescription={showDescription}
              itemCssClassName={itemClass}
              isLeadTypeTwo
              isVerticalTile={featuredCardType === 'isVerticalTile'}
              newga={`${props.newga}0/${item.wu}`}
              htmlKeys={htmlKeys}
              imgFit={imgFit}
              imgWidth={imgWidth}
              key={item.id || `${item.tn}_${index}`}
              timeStampHtml={renderTimeStamp(
                item,
                timeStampFun,
                timeStampFormat,
              )}
              isPrimeStory={isPrimeStory}
              viewga={spotlightGA}
            />
          );
        })}
      {nonFeaturedListWrapperClass ? (
        <div className={nonFeaturedListWrapperClass}>
          {renderList(
            data,
            nonFeaturedItemWrapperClass,
            itemClass,
            nonFeaturedListTileType,
            props.newga,
            htmlKeys,
            imgFit,
            imgWidth,
            isInlineSmallIconCard,
            timeStampFun,
            timeStampFormat,
          )}
        </div>
      ) : (
        renderList(
          data,
          nonFeaturedItemWrapperClass,
          itemClass,
          nonFeaturedListTileType,
          props.newga,
          htmlKeys,
          imgFit,
          imgWidth,
          isInlineSmallIconCard,
          timeStampFun,
          timeStampFormat,
        )
      )}
    </>
  );
}

export default CardList;
